export default "__VITE_ASSET__m8$h6xQt__"